module.exports = __webpack_public_path__ + "static/handshake-76c4496cc5fab440ee81e2c612536f30.jpg";